import { render, staticRenderFns } from "./OfferCard.vue?vue&type=template&id=81c3faee&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=ts"
export * from "./OfferCard.vue?vue&type=script&lang=ts"
import style0 from "./OfferCard.vue?vue&type=style&index=0&id=81c3faee&prod&lang=css"
import style1 from "./OfferCard.vue?vue&type=style&index=1&id=81c3faee&prod&scoped=true&lang=css"
import style2 from "./OfferCard.vue?vue&type=style&index=2&id=81c3faee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c3faee",
  null
  
)

export default component.exports